import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Select Export Data ")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "headline" }, "Choose Warehouse(s) to export", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("mdi-close-circle")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Export Data ")

import { computed, PropType, reactive, watch } from 'vue';
import PrimaryButton from '@/components/buttons/PrimaryButton.vue';
import { INovaWarehouse } from '@/interfaces/nova';


export default /*#__PURE__*/_defineComponent({
  __name: 'WarehouseSelectDialog',
  props: {
  warehouses: {
    type: Array as PropType<INovaWarehouse[]>,
    required: true
  },
  loading: {
    type: Boolean,
    required: false,
    default: false
  },
  isDialogVisible: {
    type: Boolean,
    required: false,
    default: false
  }
},
  emits: ['close', 'load-warehouses', 'export-data'],
  setup(__props, { emit }) {

const props = __props

/* global defineProps, defineEmits */





const state = reactive({
  warehousesToExport: [] as string[],
  shouldShowDialog: false
});

const exportWarehouseData = () => {
  emit('export-data', state.warehousesToExport);
  close(false);
};

const allSelected = computed(() => state.warehousesToExport.length === props.warehouses.length);
const selectAllLabel = computed(() => (allSelected.value ? 'Deselect All' : 'Select All'));

const toggleSelectAll = () => {
  if (allSelected.value) {
    deselectAll();
  } else {
    selectAll();
  }
};

const selectAll = () => {
  state.warehousesToExport = props.warehouses.map(
    (warehouse: INovaWarehouse) => warehouse.externalId
  );
};

const deselectAll = () => {
  state.warehousesToExport = [];
};

const close = (shouldClearWarehouses = true) => {
  emit('close', shouldClearWarehouses);
  state.warehousesToExport = [];
};

watch(
  () => props.isDialogVisible,
  isDialogVisible => {
    state.shouldShowDialog = isDialogVisible;
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: state.shouldShowDialog,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.shouldShowDialog) = $event)),
    width: 500,
    persistent: "",
    scrollable: ""
  }, {
    activator: _withCtx(({ attrs }) => [
      _createVNode(PrimaryButton, _mergeProps({
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('load-warehouses')), ["stop"]))
      }, attrs, {
        loading: props.loading,
        "append-icon": "mdi-dock-window"
      }), {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 2
      }, 1040, ["loading"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "dialog-box",
        width: 500
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "px-6 d-flex align-center" }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                class: "pa-3",
                icon: "",
                elevation: 0,
                onClick: close
              }, {
                default: _withCtx(() => [
                  (!props.loading)
                    ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, { class: "px-8 pb-6 pt-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, { fluid: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_checkbox, {
                    "hide-details": "auto",
                    label: _unref(selectAllLabel),
                    "input-value": _unref(allSelected),
                    value: "",
                    onChange: toggleSelectAll
                  }, null, 8, ["label", "input-value"]),
                  _createVNode(_component_v_divider),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.warehouses, (warehouse) => {
                    return (_openBlock(), _createBlock(_component_v_checkbox, {
                      "hide-details": "auto",
                      key: warehouse.externalId ?? warehouse.id,
                      modelValue: state.warehousesToExport,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.warehousesToExport) = $event)),
                      label: warehouse.name,
                      "return-object": "",
                      value: warehouse.externalId ?? warehouse.id
                    }, null, 8, ["modelValue", "label", "value"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(PrimaryButton, {
                loading: props.loading,
                "prepend-icon": "mdi-download",
                onClick: exportWarehouseData
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["loading"]),
              _createVNode(_component_v_spacer)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})